import { useState, useEffect, useCallback, useRef } from "react";
import { usePathname } from "next/navigation";
import { mixpanelTrack } from "@helpers/mixpanel.helper";

function ScrollTracker() {
	const pathname = usePathname();
	const [scrollDepth, setScrollDepth] = useState(0);
	const thresholds = [25, 50, 75, 100];
	const trackedThresholdsRef = useRef(new Set());

	const calculateScrollDepth = useCallback(() => {
		const winScroll =
			document.body.scrollTop || document.documentElement.scrollTop;
		const height =
			document.documentElement.scrollHeight -
			document.documentElement.clientHeight;
		const scrolled = (winScroll / height) * 100;
		setScrollDepth(scrolled);
	}, []);

	useEffect(() => {
		// Reset on route change
		setScrollDepth(0);
		trackedThresholdsRef.current.clear();
	}, [pathname]);

	useEffect(() => {
		window.addEventListener("scroll", calculateScrollDepth);
		return () => window.removeEventListener("scroll", calculateScrollDepth);
	}, [calculateScrollDepth]);

	useEffect(() => {
		for (const threshold of thresholds) {
			if (
				scrollDepth >= threshold &&
				!trackedThresholdsRef.current.has(threshold)
			) {
				trackedThresholdsRef.current.add(threshold);
				mixpanelTrack("page_scrolled", {
					page_name: pathname,
					page_portion: `${threshold}%`,
				});
			}
		}
	}, [pathname, scrollDepth]);

	return null;
}

export default ScrollTracker;
